 
import testHttp from "../../http-common";

export const userLogin = (loginDetails) => {
  return testHttp.post("/auth/login", loginDetails);
};

export const garageLogin = (loginDetails) => {
  return testHttp.post("/auth/garage/login", loginDetails);
};
